import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../utils';

/** This renders a toolbar (generally used in the page header) that contains
 *  search and filters */
export class Toolbar extends Component {
  static propTypes = {
    /** children are rendered inside of the toolbar */
    children: PropTypes.any,
    /** adds the className to the toolbar wrapper */
    toolbarClass: PropTypes.string,
  };

  render() {
    const { toolbarClass } = this.props;
    const toolbarClassName = formatClassName(['page-toolbar', toolbarClass]);

    return (
      <div className={toolbarClassName} data-page-toolbar={true}>
        {this.props.children}
      </div>
    );
  }
}
